module.exports = __webpack_public_path__ + "static/img/banner-2.8ad8dbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-2.jpg
// module id = MsBi
// module chunks = 1